// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V6ZM6 10V11C6 14.3137 8.68629 17 12 17C15.3137 17 18 14.3137 18 11V10H20V11C20 15.0796 16.9463 18.446 13 18.9381V20H18V22H6V20H11V18.9381C7.05369 18.446 4 15.0796 4 11V10H6Z"}}]};

const Microphone1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'microphone-1-filled',
    ref,
    icon: element,
  },
));

Microphone1FilledIcon.displayName = 'Microphone1FilledIcon';

export default Microphone1FilledIcon;
